import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  private readonly permissions = signal<Set<string>>(new Set());

  setPermissions(permissions: string[]): void {
    this.permissions.set(new Set(permissions));
  }

  clearPermissions(): void {
    this.permissions.set(new Set());
  }

  hasAll(requiredPermissions?: readonly string[]): boolean {
    if (!requiredPermissions?.length) {
      return true;
    }

    const currentPermissions = this.permissions();
    return requiredPermissions.every((permission) => currentPermissions.has(permission));
  }
}
